var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['zg-chip', {
    'zg-chip--with-icons': _vm.icons.left || _vm.icons.right,
    'zg-chip--selected': _vm.selected,
    'zg-chip--disabled': _vm.disabled,
    'zg-chip--full-width': _vm.fullWidth,
    [`zg-chip--size-${_vm.size}`]: _vm.size
  }],attrs:{"type":"button"}},[(_vm.icons && _vm.icons.left)?_c('zg-icon',{attrs:{"icon":_vm.icons.left,"rotate":_vm.icons.leftRotation}}):_vm._e(),_vm._v(" "),(_vm.text)?_c('span',[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.icons && _vm.icons.right)?_c('zg-icon',{attrs:{"icon":_vm.icons.right,"rotate":_vm.icons.rightRotation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }